import React from 'react';

const ProductImagesGallery = ({ images, onImageClick }) => {
  // Handle case when there are no images yet
  if (images.length === 0) {
    return (
      <div className="grid grid-cols-2 gap-2">
        <div className="col-span-2 flex justify-center items-center h-40 bg-gray-100 rounded-md">
          <p className="text-gray-500">No product images available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-1">
      {/* Display the first 2 images in the first row */}
      {images.slice(0, 2).map((image, index) => (
        <div key={`top-${image.imageId || index}`} className="w-3/4 h-1/2">
          <div
            className="aspect-square bg-white rounded-md overflow-hidden cursor-pointer border border-gray-200 hover:border-yellow-400 transition-colors"
            onClick={() => onImageClick(image, index)}
          >
            <img
              src={image.url}
              alt={`Product ${index + 1}`}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      ))}

      {/* Display the next 2 images in the second row if they exist */}
      {images.length > 2 && (
        <>
          {images.slice(2, 4).map((image, index) => (
            <div
              key={`bottom-${image.imageId || index}`}
              className="col-span-0 w-3/4 h-1/2"
            >
              <div
                className="aspect-square bg-white rounded-md overflow-hidden cursor-pointer border border-gray-200 hover:border-yellow-400 transition-colors"
                onClick={() => onImageClick(image, index + 2)}
              >
                <img
                  src={image.url}
                  alt={`Product ${index + 3}`}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default ProductImagesGallery;
